import { get, set, del } from 'idb-keyval';
import type { PersistStorage, StorageValue } from 'zustand/middleware';

/** Discard persisted carts/orders older than this — prevents a previous
 * customer's session leaking into the next one. */
export const PERSIST_TTL_MS = 30 * 60 * 1000;

/**
 * Zustand `persist` storage backed by IndexedDB (idb-keyval) with a TTL.
 * On read, if the stored envelope is older than PERSIST_TTL_MS we drop it.
 */
export function createIdbStorage<S>(): PersistStorage<S> {
  return {
    getItem: async (name) => {
      const raw = await get<{ value: StorageValue<S>; savedAt: number }>(name);
      if (!raw) return null;
      if (Date.now() - raw.savedAt > PERSIST_TTL_MS) {
        await del(name);
        return null;
      }
      return raw.value;
    },
    setItem: async (name, value) => {
      await set(name, { value, savedAt: Date.now() });
    },
    removeItem: async (name) => {
      await del(name);
    },
  };
}
